



import { Link } from "react-router-dom";

const ArrowRight = () => (
  <svg
    className="nf-arrow"
    viewBox="0 0 13 13"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
  >
    <path
      d="M1 6.5h11M7 1l5.5 5.5L7 12"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default function NotFound() {
  return (
    <main className="nf-root" aria-label="Page not found">
      {/* Subtle block-print background motif */}
      <div className="nf-bg-motif" aria-hidden="true" />

      {/* Top accent line */}
      <div className="nf-line-top" aria-hidden="true" />

      {/* Eyebrow */}
      <p className="nf-eyebrow">Page not found</p>

      {/* 404 Number */}
      <div className="nf-number" aria-label="404">
        404
        <span className="nf-number-ghost" aria-hidden="true">
          404
        </span>
      </div>

      {/* Ornament divider */}
      <div className="nf-divider" aria-hidden="true">
        <span className="nf-divider-line" />
        <span className="nf-divider-diamond" />
        <span className="nf-divider-line" />
      </div>

      {/* Heading */}
      <h1 className="nf-heading">
        Lost in the <em>weave</em>
      </h1>

      {/* Subtext */}
      <p className="nf-subtext">
        The page you're looking for seems to have unravelled.
        <br />
        Let us guide you back to our curated collection.
      </p>

      {/* CTA Buttons */}
      <div className="nf-btn-row">
        <Link to="/" className="nf-btn-primary">
          Return Home
          <ArrowRight />
        </Link>
        <Link to="/shop" className="nf-btn-secondary">
          Browse Collection
          <ArrowRight />
        </Link>
      </div>

      {/* Bottom accent line */}
      <div className="nf-line-bottom" aria-hidden="true" />

      {/* Quick category links */}
      {/* <nav className="nf-quick-links" aria-label="Quick links">
        <Link to="/shop?category=sarees" className="nf-quick-link">
          Sarees
        </Link>
        <Link to="/shop?category=lehengas" className="nf-quick-link">
          Lehengas
        </Link>
        <Link to="/shop?category=kurtas" className="nf-quick-link">
          Kurtas
        </Link>
        <Link to="/shop?category=accessories" className="nf-quick-link">
          Accessories
        </Link>
      </nav> */}
    </main>
  );
}
